/**
 * HotelsMobilePresenter — Mobile UI strategy for hotels.
 *
 * Renders rooms via HotelsMobileCarousel (3D carousel appended to document.body),
 * shows toasts via the carousel's built-in toast.
 *
 * Simplified version of MobilePresenter — no cart/fly-to-cart, just booking.
 */
import { HotelsMobileCarousel } from './HotelsMobileCarousel.js';

export class HotelsMobilePresenter {

  constructor(config = {}) {
    this.primaryColor = config.primaryColor || '#2563eb';
    this.onRoomBook = config.onRoomBook || (() => {});
    this.carousel = null;
  }

  showRooms(rooms, title) {
    if (!this.carousel) {
      this.carousel = new HotelsMobileCarousel({
        primaryColor: this.primaryColor,
        onRoomBook: (cardEl, room) => {
          this.onRoomBook(room);
        },
        onClose: () => {},
      });
    }
    this.carousel.show(rooms, title);
  }

  hideRooms() {
    if (this.carousel) {
      this.carousel.hide();
    }
  }

  onRoomBooked(room) {
    if (this.carousel?.container) {
      this.carousel.showToast(room.name || room.roomName || 'Room');
    }
  }

  updateBooking(bookingInfo) {
    // Mobile doesn't show an inline booking summary — handled by voice
  }

  destroy() {
    if (this.carousel) {
      this.carousel.destroy();
      this.carousel = null;
    }
  }
}
